export enum OrganizationCardFormField {
  CODE = 'code',
  NAME = 'name',
  PARENT_CODE = 'parentCode',
  INN = 'companyInn',
  KPP = 'companyKpp',
  ORG_TYPE_CODE = 'organizationTypeCode',
  ORG_TYPE_NAME = 'organizationTypeName',
  ADRESS = 'companyLegalAdress',
  COMPANY_FULL_NAME = 'companyFullName',
  COMPANY_SHORT_NAME = 'companyShortName',
  COMPANY_CODE = 'companyCode',
  BUSINESS_TYPE_CODE = 'businessTypeCode',
}
